export default [
  {
    path: '/admin/service-managements',
    name: 'service-management',
    meta: { requiresAuth: true },
    component: () => import('@/pages/service-management/home/index.vue')
  }
]
